import styled from 'styled-components'

import { colors, spacing } from '../../Global/theme'

export const StyledText = styled.p`
  margin: 0;

  color: ${({ disabled, color }) => {
    if (disabled) return colors.grays[40]
    return colors[color]?.regular ?? colors.primary.regular
  }};

  margin-bottom: ${({ marginBottom }) => spacing[marginBottom] ?? 0};

  text-align: ${({ align }) => {
    switch (align) {
      case 'center': return 'center'
      case 'right': return 'right'
      default: return 'left'
    }
  }};

  ${({ weight }) => {
    switch (weight) {
      case 'light': return 'font-weight: 300'
      case 'semibold': return 'font-weight: 600'
      case 'bold': return 'font-weight: 700'
      default: return 'font-weight: 400'
    }
  }};

  ${({ size }) => {
    switch (size) {
      case 'xsmall': return 'font-size: 8px'
      case 'small': return 'font-size: 10px'
      case 'large': return 'font-size: 14px'
      case 'xlarge': return 'font-size: 15px'
      case 'xxlarge': return 'font-size: 24px'
      default: return 'font-size: 12px'
    }
  }}
`
